import { tv } from "../../variants/tv.js";
const collapsibleVariants = tv({
    slots: {
        root: 'flex flex-col',
        trigger: 'focus-visible:ring-primary-8 hover:bg-primary-2 flex w-full cursor-pointer items-center justify-between rounded-xl px-4 py-3 [transition-duration:var(--transition-duration-long)] focus-visible:outline-none focus-visible:ring-2 motion-reduce:transition-none',
        panel: 'flex h-[var(--collapsible-panel-height)] flex-col overflow-hidden [transition-duration:var(--transition-duration-long)] data-[ending-style]:h-0 data-[starting-style]:h-0 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0 motion-reduce:transition-none',
        footerTrigger: 'focus-visible:ring-primary-8 group flex cursor-pointer items-center [transition-duration:var(--transition-duration-long)] focus-visible:outline-none focus-visible:ring-2 motion-reduce:transition-none',
        footer: 'text-heading6 text-actionPrimary-8 hover:text-actionPrimary-9 focus-visible:ring-primary-8 flex items-center [transition-duration:var(--transition-duration-long)] hover:underline focus-visible:outline-none focus-visible:ring-2 motion-reduce:transition-none'
    },
    variants: {
        isOpen: {
            true: {},
            false: {}
        },
        flushAligned: {
            true: {
                trigger: 'before:-z-1 hover:before:bg-primary-2 relative px-0 before:absolute before:inset-0 before:-mx-2 before:rounded-xl before:border-0 before:[transition-duration:var(--transition-duration-long)] before:motion-reduce:transition-none'
            },
            false: {}
        },
        elevated: {
            true: {
                root: 'rounded-xl border border-transparent shadow-lg [transition-duration:var(--transition-duration-long)] hover:shadow-xl motion-reduce:transition-none',
                trigger: 'rounded-xl hover:bg-transparent'
            },
            false: {}
        },
        plain: {
            true: {
                trigger: 'hover:bg-primary-1 text-left'
            },
            false: {}
        }
    },
    compoundVariants: [
        {
            elevated: true,
            isOpen: true,
            class: {
                root: 'border-primary-5 shadow-none hover:shadow-none',
                trigger: 'hover:bg-primary-2 rounded-b-none rounded-t-xl'
            }
        },
        {
            flushAligned: true,
            class: {
                trigger: 'rounded-none'
            }
        }
    ],
    defaultVariants: {
        flushAligned: false,
        elevated: false,
        plain: false,
        isOpen: false
    }
});
export { collapsibleVariants };
